import { render, staticRenderFns } from "./preview-navbar.vue?vue&type=template&id=0c72d809&scoped=true"
import script from "./preview-navbar.vue?vue&type=script&lang=ts"
export * from "./preview-navbar.vue?vue&type=script&lang=ts"
import style0 from "./preview-navbar.vue?vue&type=style&index=0&id=0c72d809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72d809",
  null
  
)

export default component.exports